<template>
    <div class="container pt-6 pb-10">
        <div class="flex justify-between items-center py-2 mb-4">
            <h1 class="page-title">Clienti</h1>
            <v-dialog v-model="addLeadModal" max-width="600px">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn color="teal" class="uppercase white-text" v-bind="attrs" v-on="on">
                        Adauga client nou
                    </v-btn>
                </template>
                <AddLead :user="user" @closeModal="addLeadModal = false" />
            </v-dialog>
        </div>

        <v-toolbar flat color="light-grey" class="rounded mb-4">
            <div class="flex flex-row justify-between items-center gap-10">
                <div class="w-1/2 flex flex-row justify-start items-center flex-grow-0 gap-2">
                    <!-- <v-text-field v-model="searchClient" clearable flat solo hide-details
                            @keydown.enter="searchSalesLeads" @click:clear="resetInitialSalesLeads"
                            prepend-inner-icon="mdi-magnify" label="Cauta oferta dupa client">
                        </v-text-field> -->
                    <v-text-field v-model="filterInput" clearable flat solo hide-details
                        prepend-inner-icon="mdi-magnify" label="Cauta client dupa nume"></v-text-field>
                    <!-- <v-btn color="blue-grey" class="uppercase" large dark @click="searchSalesLeads">Cauta</v-btn> -->
                </div>
                <div class="flex justify-end items-center flex-grow-0 gap-2">
                    <v-select ref="selectAgent" v-model="filterAgent" class="w-60" :items="agents" item-text="username"
                        item-value="id_user" :clearable="['admin', 'superuser', 'user'].includes(user.rol)"
                        @click:clear="$refs.selectAgent.blur()" label="Agent" solo hide-details></v-select>
                    <!-- <div class="w-60">
                            <v-menu v-model="monthpickerMenu" class="w-60" :close-on-content-click="false" :nudge-left="40"
                            transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="monthText" class="date-field"
                                :class="{ 'opacity-60': isSalesLeadsSearchList }" label="Luna" solo
                                prepend-inner-icon="mdi-calendar" hide-details readonly v-bind="attrs"
                                v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="selectedMonth" no-title type="month"
                            @input="changeMonth"></v-date-picker>
                        </v-menu>
                    </div> -->

                </div>
            </div>
        </v-toolbar>

        <v-sheet class="p-4 rounded mb-1 flex flex-row justify-end gap-20">
            <div>
                <v-label>Contactati / total</v-label>
                <p class="text-2xl text-black font-bold mb-0">{{ calledNo }}</p>
            </div>
        </v-sheet>

        <v-data-table v-if="salesLeads.length" class="pb-0" :headers="headers"
            :items="filterBy(salesLeads, filterInput, selectedUser)" :loading="loadingSalesLeads" :items-per-page="-1"
            hide-default-footer>
            <template v-if="isSalesLeadsSearchList" v-slot:top>
                <div class="text-lg text-primary font-medium p-4 border-b border-primary">Rezultate cautare</div>
            </template>
            <template v-slot:item.data="{ item }">
                {{ item.createdAt | formatDate }}
            </template>
            <template v-slot:item.turnover="{ item }">
                {{ getTurnoverText(item.turnover) }}
            </template>
            <template v-slot:item.net_profit="{ item }">
                {{ getProfitText(item.net_profit) }}
            </template>
            <template v-slot:item.employees="{ item }">
                {{ getEmployeeText(item.employees) }}
            </template>
            <template v-slot:item.orderMotive="{ item }">
                <div class="flex items-center gap-2">
                    <v-tooltip v-if="item.reject_reason" left color="black">
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon color="primary" v-bind="attrs" v-on="on">
                                mdi-trending-down
                            </v-icon>
                        </template>
                        <span>{{ item.reject_reason }}</span>
                    </v-tooltip>
                    <span v-else> - </span>
                    <v-icon color="teal" @click="changeRejectReason(item)">
                        mdi-pencil
                    </v-icon>
                </div>
            </template>
            <template v-slot:item.interest="{ item }">
                <div class="flex items-center gap-2">
                    <v-tooltip v-if="item.interest" left :color="item.interest">
                        <template v-slot:activator="{ on, attrs }">
                            <span v-if="item.interest" class="inline-block w-5 h-5 rounded-full" v-bind="attrs"
                                v-on="on" :class="getColorClass(item.interest)"></span>
                        </template>
                        <span>{{ getInterestText(item.interest) }}</span>
                    </v-tooltip>
                    <span v-else> - </span>
                    <v-icon color="teal" @click="changeInterestStatus(item)">
                        mdi-pencil
                    </v-icon>
                </div>
            </template>
            <template v-slot:item.actions="{ item }">
                <Actions :item="item" :user="user" />
            </template>
            <template v-slot:item.details="{ item }">
                <v-btn text rounded color="primary" @click="openSideModal(item)">detalii</v-btn>
            </template>
        </v-data-table>

        <template v-if="visibleSideModal">
            <!-- Overlay -->
            <div class="overlay" @click="closeSideModal"></div>
            <SideModal :lead="selectedLead" :user="user" :offers-count="selectedLeadOffersCount"
                :loadingOffersCount="loadingOffersCount" :lead-actions="selectedLeadActions"
                :loadingLeadActions="loadingLeadActions" @closeModal="closeSideModal" />
        </template>

        <!-- <AlertDeadline :selected-month="selectedMonth" class="w-1/2 mx-auto my-8" /> -->

        <!-- <v-dialog v-model="visibleOrderMotiveModal" max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="text-h5">Schimba motiv refuz</span>
                </v-card-title>
                <v-form ref="rejectForm" v-model="validRejectForm" @submit.prevent="updateLeadRejectReason">
                    <v-card-text>
                        <h3>De ce nu a comandat de la noi?</h3>
                        <v-radio-group v-model="changedRejectReasonItem.reason" row :rules="[rules.required]">
                            <v-radio v-for="item in rejectMotives" :key="item.value" :label="item.text" color="teal"
                                class="mb-2" :value="item.value">
                            </v-radio>
                        </v-radio-group>
                    </v-card-text>
                    <div class="flex flex-row justify-end gap-2 mt-4 p-4">
                        <v-btn color="blue-grey" class="uppercase" dark large
                            @click="closeRejectMotiveModal">Anuleaza</v-btn>
                        <v-btn color="teal" dark class="uppercase" large type="submit">Salveaza</v-btn>
                    </div>
                </v-form>
            </v-card>
        </v-dialog> -->

        <div class="invisible bg-orange-500">indiv</div>

        <v-dialog v-model="visibleInterestModal" max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="text-h5">Schimba interes prospect</span>
                </v-card-title>
                <v-form ref="interestForm" v-model="validInterestForm" @submit.prevent="updateLeadInterestStatus">
                    <v-card-text>
                        <h3>Este interesat de o colaborare cu noi?</h3>
                        <v-radio-group v-model="changedInterestStatusItem.interest" row :rules="[rules.required]">
                            <v-radio v-for="item in interestOptions" :key="item.value" :label="item.text"
                                :color="item.color" class="mb-2" :value="item.value">
                            </v-radio>
                        </v-radio-group>
                    </v-card-text>
                    <div class="flex flex-row justify-end gap-2 mt-4 p-4">
                        <v-btn color="blue-grey" class="uppercase" dark large
                            @click="closeInterestModal">Anuleaza</v-btn>
                        <v-btn color="teal" dark class="uppercase" large type="submit">Salveaza</v-btn>
                    </div>
                </v-form>
            </v-card>
        </v-dialog>

        <!-- <pre>
    {{ salesLeads }}
</pre> -->
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import AddLead from "./AddLead.vue";
// import AlertDeadline from "./AlertDeadline.vue";
import Actions from "./Actions.vue";
import SideModal from "./SideModal.vue";

export default {
    components: {
        AddLead,
        // AlertDeadline,
        Actions,
        SideModal
    },
    name: 'Leads',
    data() {
        return {
            visibleSideModal: false,
            selectedLead: {},
            selectedLeadOffersCount: null,
            loadingOffersCount: false,
            selectedLeadActions: [],
            loadingLeadActions: false,
            addLeadModal: false,
            visibleInterestModal: false,
            validInterestForm: false,
            // visibleOrderMotiveModal: false,
            // validRejectForm: false,
            searchClient: null,
            monthpickerMenu: false,
            selectedMonth: new Date().toISOString().substring(0, 7),
            headers: [
                { text: 'Data', value: 'data', align: 'start', sortable: false },
                { text: 'Client', value: 'nume', align: 'start', sortable: false },
                { text: 'Cifra de afaceri', value: 'turnover', align: 'start', width: '14%', sortable: false },
                { text: 'Profit', value: 'net_profit', align: 'start', width: '14%', sortable: false },
                { text: 'Angajati', value: 'employees', align: 'start', width: '5%', sortable: false },
                { text: 'Domeniu activitate', value: 'activity_field', align: 'start', sortable: false },
                { text: 'Interes', value: 'interest', align: 'start', sortable: false },
                { text: 'Actiuni', value: 'actions', align: 'center', sortable: false },
                { text: 'Adaugat de', value: 'username', align: 'start', sortable: false },
                { value: 'details', sortable: false, width: '5%' }
            ],
            filterInput: null,
            selectedUser: null,
            changedInterestStatusItem: {},
            changedRejectReasonItem: {},
            rules: {
                required: value => !!value || 'Câmp obligatoriu'
            }
        }
    },
    computed: {
        ...mapState('salesLeads', ['salesLeads', 'loadingSalesLeads', 'isSalesLeadsSearchList', 'interestOptions', 'rejectMotives', 'turnoverOptions', 'profitOptions', 'activityFields', 'employeeOptions']),
        user() {
            return this.$store.getters.loggedUser;
        },
        monthText() {
            return this.$options.filters.formatMonth(this.selectedMonth)
        },
        firstDay() {
            return new Date(this.selectedMonth).toISOString().split('T')[0]
        },
        lastDay() {
            return new Date(new Date(this.selectedMonth).getFullYear(), new Date(this.selectedMonth).getMonth() + 1, 1).toISOString().split('T')[0]
        },
        calledNo() {
            return this.salesLeads.filter(lead => {
                if (this.selectedUser) {
                    return lead.id_user === this.selectedUser && +lead.called;
                }
                // If no user is selected, count all leads that are called
                return +lead.called
            }).length + ' / ' + (this.selectedUser ? this.salesLeads.filter(lead => lead.id_user === this.selectedUser).length : this.salesLeads.length);
        },
        filterAgent: {
            get: function () {
                return this.selectedUser
            },
            // setter
            set: function (newValue) {
                this.selectedUser = newValue
            },
        },
        agents() {
            let array = [];
            let user = {};

            this.salesLeads.forEach((lead) => {
                user = {
                    id_user: lead.id_user,
                    username: lead.username,
                };
                if (this.containsObject(user, array)) {
                    return;
                } else {
                    array.push(user);
                }
            });
            return array.filter(this.onlyUnique);
        }
    },
    methods: {
        ...mapActions('salesLeads', ["fetchSalesLeads", "fetchSalesLeadsActions", "searchSalesLeads", "changeLeadRejectReason", "changeLeadInterestStatus"]),
        ...mapActions('salesOffers', ["countSalesClientOffers"]),
        escapeRegExp(s) {
            return s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
        },
        onlyUnique(value, index, arr) {
            return arr.indexOf(value) === index;
        },
        containsObject(obj, list) {
            var i;
            for (i = 0; i < list.length; i++) {
                if (list[i].id_user === obj.id_user) {
                    return true;
                }
            }
            return false;
        },
        filterBy(list, value, agent) {
            if (!value) {
                value = ""
            }
            const words = value
                .split(/\s+/g)
                .map((s) => s.trim())
                .filter((s) => !!s);

            const hasTrailingSpace = value.endsWith(" ");

            const searchRegex = new RegExp(
                words
                    .map((word, i) => {
                        if (i + 1 === words.length && !hasTrailingSpace) {
                            // The last word - ok with the word being "startswith"-like
                            return `(?=.*\\b${this.escapeRegExp(word)})`;
                        } else {
                            // Not the last word - expect the whole word exactly
                            return `(?=.*\\b${this.escapeRegExp(word)}\\b)`;
                        }
                    })
                    .join("") + ".+",
                "i"
            );

            // See if current user has oferte
            let userLeads = this.agents.find((item) => {
                return item.id_user == agent;
            });
            // filter different cases
            return list.filter((lead) => {
                if (userLeads == undefined) {
                    return searchRegex.test(lead.nume);
                } else {
                    return (
                        searchRegex.test(lead.nume) &&
                        lead.id_user == agent
                    );
                }
            });
        },
        changeMonth() {
            this.monthpickerMenu = false
            this.fetchSalesLeads({ fromDate: this.firstDay, toDate: this.lastDay })
        },
        getTurnoverText(turnover) {
            const turnoverOption = this.turnoverOptions.find(option => option.value === Number(turnover));
            return turnoverOption ? turnoverOption.text : 'N/A';
        },
        getProfitText(profit) {
            const profitOption = this.profitOptions.find(option => option.value === Number(profit));
            return profitOption ? profitOption.text : 'N/A';
        },
        getEmployeeText(employees) {
            const employeeOption = this.employeeOptions.find(option => option.value === Number(employees));
            return employeeOption ? employeeOption.text : 'N/A';
        },
        resetInitialSalesLeads() {
            this.fetchSalesLeads({ fromDate: this.firstDay, toDate: this.lastDay });
        },
        openSideModal(item) {
            this.selectedLead = Object.assign({}, { id: item.id, name: item.nume, clientId: item.client_id, interest: item.interest })
            this.fetchCountOffers(item.client_id)
            this.fetchLeadActions(item.id)
            this.visibleSideModal = true
        },
        async fetchCountOffers(clientId) {
            this.loadingOffersCount = true
            const offersCount = await this.countSalesClientOffers(clientId)
            this.selectedLeadOffersCount = offersCount.count
            this.loadingOffersCount = false
        },
        async fetchLeadActions(leadId) {
            this.loadingLeadActions = true
            const actions = await this.fetchSalesLeadsActions(leadId)
            this.selectedLeadActions = actions
            this.loadingLeadActions = false
        },
        closeSideModal() {
            this.visibleSideModal = false
            this.$nextTick(() => {
                this.selectedLead = Object.assign({}, {})
                this.selectedLeadOffersCount = null
                this.selectedLeadActions = []
            })
        },
        getColorClass(interest) {
            return `bg-${interest}-500`;
        },
        // changeRejectReason(item) {
        //     this.changedRejectReasonItem = Object.assign({}, { id: item.id, reason: item.reject_reason })
        //     this.visibleOrderMotiveModal = true
        // },
        // closeRejectMotiveModal() {
        //     this.visibleOrderMotiveModal = false
        //     this.$nextTick(() => {
        //         this.changedRejectReasonItem = Object.assign({}, {})
        //     })
        // },
        // async updateLeadRejectReason() {
        //     const valid = await this.$refs.rejectForm.validate();

        //     if (valid) {
        //         this.changeLeadRejectReason(this.changedRejectReasonItem)
        //         this.closeRejectMotiveModal()
        //     }
        // },
        changeInterestStatus(item) {
            this.changedInterestStatusItem = Object.assign({}, { id: item.id, interest: item.interest })
            this.visibleInterestModal = true
        },
        closeInterestModal() {
            this.visibleInterestModal = false
            this.$nextTick(() => {
                this.changedInterestStatusItem = Object.assign({}, {})
            })
        },
        getInterestText(interest) {
            const interestOption = this.interestOptions.find(option => option.value === interest);
            return interestOption ? interestOption.text : 'N/A';
        },
        async updateLeadInterestStatus() {
            const valid = await this.$refs.interestForm.validate();

            if (valid) {
                this.changeLeadInterestStatus(this.changedInterestStatusItem)
                this.closeInterestModal()
            }
        },
    },
    created() {
        this.fetchSalesLeads();
    },
    mounted: function () {
        if (this.user.rol == 'admin') {
            this.selectedUser = null
        } else {
            this.selectedUser = this.user.id_user
        }
    }
}
</script>

<style scoped>
.lead-details-sheet {
    @apply fixed top-0 right-0 h-full bg-white z-50
}

.overlay {
    @apply fixed top-0 left-0 w-screen h-screen bg-black bg-opacity-25 z-40
}
</style>